import { React, useEffect, useState } from "react";
import axios from "axios";
import { AdminTable, AdminCreate } from "..";
import SearchIcon from "@mui/icons-material/Search";


function AdminSearch() {
  const [adminName, setAdminName] = useState("");

  const [admins, setAdmins] = useState([]);

  const [updateTable, setUpdateTable] = useState(false);

  useEffect(() => {
    showAdminSearchResults();
  }, [adminName, updateTable]);

  const showAdminSearchResults = () => {
    const body = new FormData();
    body.append("adminName", adminName);
    axios.post("/admin/searchAdmins", body).then((res) => {
      const data = res.data;
      if (data.success) {
        setAdmins(data.admins);
      } else {
      }
    });
  };

  const resetHooks = () => {
    setAdminName("");
  };

  return (
    <div className="AdminSearch bg-brand-tertiary h-full">
      <div className="AdminSearch-container flex flex-col p-8 h-full">
        <div className="AdminSearch-topContainer flex flex-wrap">
          <div className="AdminSearch-searchBar flex search-button h-11 mr-4 w-60 mb-4">
            <input
              type="text"
              className="font-brand-quaternary h-full rounded-full ml-4 w-full"
              placeholder="Search"
              value={adminName}
              onChange={(e) => setAdminName(e.target.value)}
            />
            <div className="my-auto mx-2">
              <SearchIcon size={16} />
            </div>
          </div>

          <AdminCreate updateTable={updateTable} setUpdateTable={setUpdateTable} />

          <button type="button"
            className="AdminSearch-resetButton search-button px-4 h-11 mb-4 text-center py-2" onClick={resetHooks}>
            Reset Search
          </button>
        </div>
        <div className="AdminSearch-bottomContainer flex w-full h-full">
          <AdminTable admins={admins} updateTable={updateTable} setUpdateTable={setUpdateTable} />
        </div>
      </div>
    </div>
  );
}

export default AdminSearch;
